/** Choices for staff list Active filter (includes explicit All). */
export const STAFF_ACTIVE_FILTER_CHOICES = [
  { id: true, name: "Active" },
  { id: false, name: "Inactive" },
  { id: "all", name: "All" },
] as const;

/** Default list filter: active employees only. */
export const STAFF_LIST_DEFAULT_FILTERS = { isActive: true as const };

/** Label for soft active status chip / column. */
export function staffActiveStatusLabel(isActive: boolean | null | undefined): "Active" | "Inactive" {
  return isActive === false ? "Inactive" : "Active";
}
